var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6 8.667c.368 0 .667.298.667.666V14c0 .368-.299.667-.667.667H1.333c-.368 0-.666-.299-.666-.667V9.333c0-.368.298-.666.666-.666H6zM5.333 10H2v3.333h3.333V10zm9.334.667c.368 0 .666.298.666.666 0 .369-.298.667-.666.667h-6C8.298 12 8 11.702 8 11.333c0-.368.298-.666.667-.666zM6 1.333c.368 0 .667.299.667.667v4.667c0 .368-.299.666-.667.666H1.333c-.368 0-.666-.298-.666-.666V2c0-.368.298-.667.666-.667H6zm-.667 1.334H2V6h3.333V2.667zm3.334 1h6c.368 0 .666.298.666.666 0 .335-.246.612-.568.66L14.667 5h-6C8.298 5 8 4.702 8 4.333c0-.334.247-.611.568-.66l.099-.006h6z",
    transform: "translate(-1072 -309) translate(1040 64) translate(0 197) translate(32 48)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.212f5b95.svg";
export { ForwardRef as ReactComponent };